// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/company';
import model_2 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/customerStatus';
import model_3 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/menuPackage';
import model_4 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/partner';
import model_5 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/pbac';
import model_6 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/provinceV2';
import model_7 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/servicePackage';
import model_8 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/serviceSupporter';
import model_9 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/transitGroup';
import model_10 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/transitTag';
import model_12 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/userCompany';
import model_13 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/wardV2';
import model_14 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/.umi-production/plugin-initialState/@@initialState';
import model_11 from '/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/models/user';

export const models = {
model_1: { namespace: 'company', model: model_1 },
model_2: { namespace: 'customerStatus', model: model_2 },
model_3: { namespace: 'menuPackage', model: model_3 },
model_4: { namespace: 'partner', model: model_4 },
model_5: { namespace: 'pbac', model: model_5 },
model_6: { namespace: 'provinceV2', model: model_6 },
model_7: { namespace: 'servicePackage', model: model_7 },
model_8: { namespace: 'serviceSupporter', model: model_8 },
model_9: { namespace: 'transitGroup', model: model_9 },
model_10: { namespace: 'transitTag', model: model_10 },
model_12: { namespace: 'userCompany', model: model_12 },
model_13: { namespace: 'wardV2', model: model_13 },
model_14: { namespace: '@@initialState', model: model_14 },
model_11: { namespace: 'user', model: model_11 },
} as const
